/* eslint no-useless-escape: 0 */

module.exports = {
  addressFormat: 'addressLine1,addressLine2,city,state,postalCode',
  NACOfranOwnerId: 220,
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      addressVerificationRequired: false,
      isShippingAddressRequired: true,
      hasInstallments: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '4',
      refId: '1',
      name: '@Work eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '1',
      name: 'Online iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Digital Group Coaching',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex: "^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex: "^$|^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    city: {
      regex: '^[a-zA-Z-. ]*[a-zA-Z]+[a-zA-Z-. ]*$',
    },
    state: {
      required: true,
    },
    postalCode: {
      type: 'string',
      min: 6,
      max: 7,
      regex: '^[a-zA-Z]{1}\\d{1}[a-zA-Z]{1} *\\d{1}[a-zA-Z]{1}\\d{1}$',
      regexFlags: '',
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
    ],
  },
};
